import { Container, Row, Col } from "react-bootstrap";
import Slider from "react-slick";
import TitleSection from "@/components/titleSection";
import { SlickArrowLeft, SlickArrowRight } from "@/components/carouselArrow";
import testimonialData from "@/data/testimonial";
import GoogleReviewCard from "./GoogleReviewCard";

const DEFAULT_RESPONSIVE = [
  { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 1 } },
  { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 } },
  { breakpoint: 575, settings: { slidesToShow: 1, slidesToScroll: 1 } },
];

const OurTestimonial = ({
  sectionSpace = "pt-115 pb-90",
  bgImage = "20.webp",
  subTitle = "Our Testimonial",
  title = "Clients Feedback",
  data = testimonialData,
  slidesToShow = 4,
  slidesToScroll = 1,
  responsive = DEFAULT_RESPONSIVE,
  showArrows = true,
  sliderClassName = "ltn__testimonial-slider-5-active slick-arrow-1",
  variant = "google",
}) => {
const settings = {
  dots: false,
  infinite: true,
  speed: 400,
  autoplay: true,
  autoplaySpeed: 2000,
  pauseOnHover: true,
  cssEase: "ease-in-out",
  slidesToShow,
  slidesToScroll,
  prevArrow: showArrows ? <SlickArrowLeft /> : undefined,
  nextArrow: showArrows ? <SlickArrowRight /> : undefined,
  responsive,
};

  const wrapperStyle = bgImage
    ? { backgroundImage: `url("../img/bg/${bgImage}")` }
    : undefined;
  const wrapperClass = bgImage
    ? `ltn__testimonial-area bg-image-top ${sectionSpace}`
    : `ltn__testimonial-area ${sectionSpace}`;

  const renderCard = (item, key) =>
    variant === "google" ? (
      <GoogleReviewCard key={key} data={item} />
    ) : (
      <div key={key} className="ltn__testimonial-item ltn__testimonial-item-7">
        <p>{item.description}</p>
      </div>
    );

  return (
    <div className={wrapperClass} style={wrapperStyle}>
      <Container>
        <Row>
          <Col lg={12}>
            <TitleSection
              sectionClasses="text-center"
              headingClasses="section-subtitle-2"
              titleSectionData={{ subTitle, title }}
            />
          </Col>
        </Row>
        <Slider {...settings} className={sliderClassName}>
          {data.map(renderCard)}
        </Slider>
      </Container>
    </div>
  );
};

export default OurTestimonial;
